(function ($) {
  $.validator.setDefaults({
    ignore: []
  })
  const { adapters } = $.validator.unobtrusive
  adapters.fxbAddNumberVal = function (adapterName, attribute, ruleName) {
    attribute = attribute || 'val'
    ruleName = ruleName || adapterName
    this.add(adapterName, [attribute], (options) => {
      const attrVal = options.params[attribute]
      if ((attrVal || attrVal === 0) && !isNaN(attrVal)) {
        options.rules[ruleName] = Number(attrVal)
      }
      if (options.message) {
        options.messages[ruleName] = options.message
      }
    })
  }

  adapters.fxbAddMinMax = function (adapterName, minRuleName, maxRuleName, minAttribute, maxAttribute) {
    minAttribute = minAttribute || 'min'
    maxAttribute = maxAttribute || 'max'

    this.add(adapterName, [minAttribute, maxAttribute], (options) => {
      const hasAttribute = options.params[minAttribute] && options.params[maxAttribute]
      const message = options.message
      if (hasAttribute) {
        [minRuleName, maxRuleName].forEach(rule => {
          if (message) {
            options.messages[rule] = message
          }
        })
      }
    })
  }

  adapters.addBool('ischecked', 'required')

  adapters.addBool('no-special-chars')
  $.validator.addMethod(
    'no-special-chars',
    function (value, element) {
      return !/[@$&#%^*()+=}{\[\]\/":;?\\,.`~|]/.test(value)
    }
  )

  adapters.addBool('special-chars')
  $.validator.addMethod(
    'special-chars',
    function (value, element) {
      return /[!@$&#%^*_()+=}{\[\]\/'":;?\\,-.<>`~|]/.test(value)
    }
  )

  adapters.addBool('has-no-password-as-input')
  $.validator.addMethod(
    'has-no-password-as-input',
    function (value, element) {
      return !/password/.test(value.toLowerCase())
    }
  )

  adapters.addBool('consecutive-characters')
  $.validator.addMethod(
    'consecutive-characters',
    function (value, element) {
      return /^(?!.*(.)\1\1)/.test(value.toLowerCase())
    }
  )

  adapters.addBool('phone-number')
  $.validator.addMethod(
    'phone-number',
    function (value, element) {
      return /[0-9\-+()]/.test(value)
    }
  )

  adapters.addBool('address')
  $.validator.addMethod(
    'address',
    function (value, element) {
      return /[0-9A-Za-z\-_#]/.test(value)
    }
  )

  adapters.addBool('zipcode')
  $.validator.addMethod(
    'zipcode',
    function (value, element) {
      return /[0-9A-Za-z\-]/.test(value)
    }
  )

  adapters.addBool('hasnumber')
  adapters.addBool('haslowercase')
  adapters.addBool('hasuppercase')
  adapters.addBool('no-empty-spaces')

  $.validator.addMethod(
    'required',
    function (value, element) {
      return value && $.trim(value) !== '';
    },
    $.validator.messages.required
  )

  $.validator.addMethod(
    'hasnumber',
    function (value, element) {
      return /[0-9]/.test(value)
    }
  )
  $.validator.addMethod(
    'haslowercase',
    function (value, element) {
      return /[a-z]/.test(value)
    }
  )
  $.validator.addMethod(
    'no-empty-spaces',
    function (value, element) {
      return /^$|^\S+(?:(?!\s{2}).)*$/.test(value);
    }
  )
  $.validator.addMethod(
    'hasuppercase',
    function (value, element) {
      return /[A-Z]/.test(value)
    }
  )

  adapters.addSingleVal('equals', 'to')
  $.validator.addMethod(
    'equals',
    function (value, element, params) {
      const primary = $(params).val()
      return primary === value
    }
  )

  adapters.addSingleVal('disabled-week', 'days')
  $.validator.addMethod(
    'disabled-week',
    function (value, element, params) {
      const days = JSON.parse(params)
      const weekDay = new Date(value).getDay() ?? 7
      return !days.find(d => d === weekDay)
    }
  )

  $.validator.addMethod(
    'daterange',
    function (value, element, params) {
      return this.optional(element) || (value >= params.min && value <= params.max)
    }
  )

  adapters.add(
    'daterange',
    ['min', 'max'],
    (options) => {
      const params = {
        min: options.params.min,
        max: options.params.max
      }
      options.rules.daterange = params
      options.messages.daterange = options.message
    }
  )

  adapters.addSingleVal('filesize', 'max')
  $.validator.addMethod(
    'filesize',
    function (value, element, max) {
      if (!this.optional(element)) {
        for (let file of element.files) {
          if (file.size > max) {
            return false
          }
        }
      }
      return true
    }
  )

  adapters.addSingleVal('filecount', 'max')
  $.validator.addMethod(
    'filecount',
    function (value, element, max) {
      if (!this.optional(element)) {
        if (element.files.length > max) {
          return false
        }
      }
      return true
    }
  )

  adapters.addSingleVal('filetype', 'allowedcontenttypes')
  $.validator.addMethod(
    'filetype',
    function (value, element, allowedContentTypes) {
      if (!this.optional(element)) {
        // Remove empty entries
        const allowedContentTypesArray = allowedContentTypes.split(',').filter((s) => s !== '')
        if (allowedContentTypesArray.length) {
          for (let file of element.files) {
            let isValid = allowedContentTypesArray
              .filter(t => [
                file.type.toLowerCase(),
                `.${file.name.split('.').pop().toLowerCase()}`
              ].includes(t.toLowerCase()))[0]

            if (!isValid) {
              return false
            }
          }
        }
      }
      return true
    }
  )

  adapters.fxbAddNumberVal('min')
  adapters.fxbAddNumberVal('max')
  adapters.fxbAddNumberVal('step')

  adapters.fxbAddMinMax('range', 'min', 'max')
  adapters.fxbAddMinMax('length', 'minlength', 'maxlength')
  adapters.fxbAddMinMax('daterange', 'min', 'max')

  $.extend( $.validator.prototype, {
    focusInvalid: function() {
      if (this.settings.focusInvalid) {
        try {
          const focusElement = $(this.findLastActive() || this.errorList.length && this.errorList[ 0 ].element || []);
          focusElement.filter( ":visible" ).trigger( "focus" ).trigger("focusin"); // Manually trigger focusin event; without it, focusin handler isn't called, findLastActive won't have anything to find
          $('html').scrollTop(focusElement.offset().top);
          focusElement.filter( ":visible" ).length && this.focusOnInvalidEl(focusElement) // Manually sets the vertical scrollbar position to the focusing element; without it, some elements don't focus on iOS
        } catch (e) {
          // Ignore IE throwing errors when focusing hidden elements
        }
      }
    },
    focusOnInvalidEl: function($element) {
      const elementTop = $element.offset().top,
            elementHeight = $element.height(),
            viewportHeight = $(window).height();

      $(window).scrollTop(elementTop - ((viewportHeight - elementHeight) / 2));
    }
  })
}($))
